
<template>
    
            
    <b-list-group class="photo_book_page_list_group">
        
        <b-list-group flush v-for="image in images" v-bind:key="image.id">
            <b-list-group-item href="#" class="photo_book_image">
                <photo-book-image :image="image"></photo-book-image>
            </b-list-group-item>
        </b-list-group>
       

    </b-list-group>


</template>


<script>
import PhotoBookImage from './PhotoBookImage';
import PhotoBookImageUploader from './PhotoBookImageUploader';
import { mapGetters, mapActions } from 'vuex';
import { Modal, BaseAlert } from '@/components'

export default {
    name: "photo-book-image-list",
    components: {
        Modal,
        BaseAlert,
        PhotoBookImage,
        PhotoBookImageUploader,
    },
    props: {
        photo_book_id: 0,
    },
    data() {
        return {
            loading: false,
            uploader: false,
            imagetype: 'interiorreq',
            images: [],
        };
    },
    methods: {
        retrievePhotoBookImages() {

                console.log("ID of book");
                console.log(this.$store.getters.currentPhotoBook.id);
            this.loading = true;
            this.$store.dispatch('fetchPhotoBookImages', this.$store.getters.currentPhotoBook.id)
            .then(() => {
                console.log(this.$store.getters.currentPhotoBookImages);
            })
            .catch((error) => {
                console.error(error);
                this.loading = true;
            }).finally(() => {
                    this.loading = false;
            });
            /*
            this.loading = true;
            let query = {};
            query["imagetype"] = this.imagetype;
            this.$api.getPhotoBookImages(this.photo_book_id, query)
                .then((response) => {
                    this.images = response.data.photo_book_images;
                })
                .catch((e) => {
                    console.log(e);
                }).finally(() => {
                    this.loading = false
                });
                */

        },
    },
    computed: {
        ...mapGetters({
            currentAccount: 'currentAccount',
            currentSettings: 'currentSettings',
            currentPhotoBook: 'currentPhotoBook',
            currentPhotoBookImages: 'currentPhotoBookImages',
        }),
        ...mapActions({
            fetchPhotoBookPage: 'fetchPhotoBookImage',
            fetchPhotoBookPages: 'fetchPhotoBookImages',
        }),
    },
    mounted() {
        console.log(this.photo_book_id);
        console.log("Loading image from sererv...");
        this.retrievePhotoBookImages();
    },
};
</script>

<style scoped>

.photo_book_image_list{
    margin-right: 0px;
    margin-left: 0px;
}
.photo_book_image{
    background-color:green;
    /*padding-top: 0;*/
    margin-top: 0;
}
</style>